import React from 'react';
import styles from './ItineraryPinCard.module.css';
import { DigitalMapPin } from 'models/digitalMap';

interface Props {
  pin: DigitalMapPin;
}

export const ItineraryPinCard: React.FC<Props> = ({ pin }) => {
  return (
    <div className={styles.card}>
      {pin.media_items?.length > 0 && (
        <img src={pin.media_items[0].url} alt="Event Main Image" className={styles.image} />
      )}
      <div className={styles.details}>
        <div className={styles.info}>{pin.title}</div>
      </div>
    </div>
  );
};
